module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-wrapper"
  }, [_c('div', {
    staticClass: "chats"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "span"
    }
  }, _vm._l((_vm.typingParticipants), function(typer) {
    return _c('span', {
      key: typer.id,
      staticClass: "chat-typer"
    }, [_vm._v(_vm._s(typer.name) + " is typing ...")])
  }), 0), _vm._v(" "), _vm._l((_vm.clusteredChats), function(clustered) {
    return _c('div', {
      staticClass: "chats-group"
    }, _vm._l((_vm.reverse(clustered)), function(chat, $index) {
      return _c('div', {
        class: {
          'chat--mine': chat.mine,
            'chat': typeof chat.mine !== 'undefined',
            'chat-status': typeof chat.mine === 'undefined'
        }
      }, [(typeof chat.mine !== 'undefined') ? _c('span', [($index === 0 && !chat.mine) ? _c('b', [_vm._v(_vm._s(chat.user.name))]) : _vm._e(), _vm._v("\n                    " + _vm._s(chat.message) + "\n                    "), _c('small', {
        staticClass: "time"
      }, [_vm._v(_vm._s(_vm._f("readableDate")(chat.createdAt, 'YYYY-MM-DD HH:mm:ss', 'HH:mm')))]), _vm._v(" "), (chat.mine) ? _c('span', {
        staticClass: "status"
      }, [(_vm.isRead(chat.statuses) || _vm.isReceived(chat.statuses)) ? _c('span', {
        class: {
          'status-read': _vm.isRead(chat.statuses)
        }
      }, [_c('icon', {
        attrs: {
          "name": "check"
        }
      }), _vm._v(" "), _c('icon', {
        attrs: {
          "name": "check"
        }
      })], 1) : _c('span', [_c('icon', {
        attrs: {
          "name": "check"
        }
      })], 1)]) : _vm._e()]) : _c('span', [(chat.createdAt && !_vm.isCreator(chat.user)) ? _c('i', [_vm._v(_vm._s(_vm._f("readableDate")(chat.createdAt, 'YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss')) + " " + _vm._s(chat.user.name) + " ist beigetreten")]) : _vm._e(), _vm._v(" "), (chat.createdAt && _vm.isCreator(chat.user)) ? _c('i', [_vm._v(_vm._s(_vm._f("readableDate")(chat.createdAt, 'YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss')) + " " + _vm._s(chat.user.name) + " hat den Chat erstellt")]) : _vm._e(), _vm._v(" "), (chat.deletedAt) ? _c('i', [_vm._v(_vm._s(_vm._f("readableDate")(chat.deletedAt, 'YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss')) + " " + _vm._s(chat.user.name) + " ist ausgetreten")]) : _vm._e()])])
    }), 0)
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "new-message"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "textarea",
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": [_vm.isTyping, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if (!$event.shiftKey) { return null; }
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": _vm.$t('common.button.send')
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('icon', {
    attrs: {
      "name": "send"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5caf4ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Chat.vue
// module id = 517
// module chunks = 234